<template>
  <div class="list-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        class="list"
        v-model="loading"
        @load="onLoad"
        :finished="finished"
        finished-text="没有更多了">
        <van-cell class="item" v-for="(item, index) in dataSource" :key="index">
          <div class="item-bg">
            <div class="amount">金额：{{ numFormat(item.tradeAmount) }}元</div>
            <div class="title" v-if="item.type == 'PUR'">
              资产名称：{{ item.name }}
            </div>
            <div class="order-num">订单号：{{ item.id }}</div>
            <div class="create-time">
              {{
                item.type == "WHC"
                  ? "提现时间："
                  : item.type == "PCU" || item.type == "PCD"
                  ? "充值时间："
                  : "下单时间："
              }}{{ item.createTime }}
            </div>
            <div class="bottom-line"></div>
            <div class="bottom-bg">
              <div
                class="status-bg"
                v-if="item.type == 'PUR' && item.status == 100">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;成功</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PUR' && item.status == 101">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;处理中，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="
                  item.type == 'PUR' &&
                  item.status == 0 &&
                  (item.signStatus == 1 || item.signStatus == 2)
                ">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">
                  &nbsp;&nbsp;待支付&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <van-count-down
                  class="status"
                  v-if="
                    (item.signStatus == 1 || item.signStatus == 2) &&
                    countDown(item) > 0
                  "
                  :time="countDown(item)"
                  @finish="onFinish(item)"
                  format="HH:mm:ss"></van-count-down>
                <!-- <van-count-down
                  class="status"
                  v-else-if="
                    (item.signStatus == 1 || item.signStatus == 2) &&
                    countDown(item) <= 0
                  "
                  format="HH:mm:ss"
                  >支付已超时</van-count-down
                > -->
              </div>
              <div
                class="status-bg"
                v-if="
                  item.type == 'PUR' && item.status == 0 && item.signStatus == 3
                ">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;签名失败</div>
              </div>
              <div
                class="status-bg"
                v-if="
                  item.type == 'PUR' && item.status == 0 && item.signStatus == 4
                ">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;拒签</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PUR' && item.status == 200">
                <template v-if="item.signStatus == 4">
                  <img
                    src="../../assets/img/my-order/faile.png"
                    alt=""
                    fit="conver" />
                  <div class="status">&nbsp;&nbsp;拒签</div>
                </template>
                <template v-else-if="item.signStatus == 3">
                  <img
                    src="../../assets/img/my-order/faile.png"
                    alt=""
                    fit="conver" />
                  <div class="status">&nbsp;&nbsp;签名失败</div>
                </template>
                <template v-else>
                  <img
                    src="../../assets/img/my-order/faile.png"
                    alt=""
                    fit="conver" />
                  <div class="status">&nbsp;&nbsp;支付失败</div>
                </template>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PUR' && item.status == 201">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;支付时间过期</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PUR' && item.status == 202">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;已撤销</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'WHC' && item.status == 1">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;申请中，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'WHC' && item.status == 8">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;撤销成功</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'WHC' && item.status == 2">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;第三方处理中，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'WHC' && item.status == 3">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;成功</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'WHC' && item.status == 4">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;付款失败</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCU' && item.status == 0">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;处理中，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCU' && item.status == 10">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;成功</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCU' && item.status == 20">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;失败</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCD' && item.status == 0">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;处理中，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCD' && item.status == 1">
                <img
                  src="../../assets/img/my-order/wait-pay.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;提交审核，请耐心等待</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCD' && item.status == 2">
                <img
                  src="../../assets/img/my-order/success.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;成功</div>
              </div>
              <div
                class="status-bg"
                v-if="item.type == 'PCD' && item.status == 3">
                <img
                  src="../../assets/img/my-order/faile.png"
                  alt=""
                  fit="conver" />
                <div class="status">&nbsp;&nbsp;失败</div>
              </div>
              <van-button
                v-if="
                  item.type == 'PUR' &&
                  item.status == 0 &&
                  (item.signStatus == 1 || item.signStatus == 2)
                "
                class="pay-btn"
                @click="onPay(item)"
                v-preventReClick
                >去支付</van-button
              >
              <van-button
                v-if="
                  item.type == 'WHC' && (item.status == 1 || item.status == 2)
                "
                class="cancel-order-btn"
                @click="onCancelWithdraw(item)"
                v-preventReClick
                >撤销</van-button
              >
            </div>
            <div
              class="tag"
              v-if="item.type == 'PUR'"
              style="background-color: rgb(100, 209, 159)">
              认购
            </div>
            <div
              class="tag"
              v-else-if="item.type == 'WHC'"
              style="background-color: rgb(253, 181, 87)">
              提现
            </div>
            <div
              class="tag"
              v-else-if="item.type == 'PCU'"
              style="background-color: rgb(252, 102, 87)">
              线上充值
            </div>
            <div
              class="tag"
              v-else-if="item.type == 'PCD'"
              style="background-color: rgb(252, 102, 87)">
              线下充值
            </div>
            <div
              class="tag"
              v-else
              style="background-color: rgb(151, 151, 151)">
              未知
            </div>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
/**
 *type PUR：认购，提现：WHC,PCL:充值，PCU:线上充值，PCD：线下充值
 */
/**
 *status 认购状态：状态0：待支付；100：成功支付；101：处理中；200：支付失败；201：支付时间过期；202：已撤销
 */
/**
 *status 提现：提现状态 1：未处理/申请中；2：第三方处理中；3：已结清 4付款失败 8 撤销成功
 */
/**
 *status 在线充值：状态0：处理中；10：成功；20：失败；
 */
/**
 *status 线下充值：状态0：处理中；1：提交审核；2：审核通过；3：审核未通过
 */
/**
 *signStatus 签名状态：签署状态 1:未签署2:签署完成 3:失败 4:拒签
 */
import { CountDown, Icon, List, PullRefresh } from "vant"
import { cancelWithdraw, getAllOrder } from "../../api/order"
import moment, { now } from "moment"
import * as PayApi from "@/api/pay"
import * as SpecialPayApi from "@/api/special"
import * as ProductApi from "@/api/product"
import session from "../../utils/session"
import { mapActions } from "vuex"
export default {
  name: "orderList",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown
  },
  props: {
    tabObject: {},
    dateObject: {}
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      finished: false,
      refreshing: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        type: "", // PUR：认购，提现：WHC,PCL:充值，PCU:线上充值，PCD：线下充值
        beginTime: "",
        endTime: ""
      },
      payForm: {
        // payAmount: 0, //支付金额
        tradeAmount: "", //交易金额
        cashCouponAmount: null, //代金券面值之和，单位元
        rateCouponAmount: null, //加息券面值之和，单位百分比
        productId: "", //  开户行名, 例如: 中国银行
        fundOutType: "2", // 1：到期自动购买同系列产品；2：到期自动转入余额；3：到期自动转入银行卡
        terminal: "H5", // 终端
        bindCardId: "", // 用户选择的银行卡的银行id
        pattern_buying: "3", //  支付方式 - 线下网银支付1/ 在线支付2/ 余额支付3,
        agreement_buying: true, // 同意服务协议及风险协议
        type: "",
        id: "", //订单ID，后端生成
        cashCouponIds: [], //带金券
        rateCouponIds: [] //加息券
      }
    }
  },
  beforeMount() {
    this.form.type = this.tabObject.type
  },
  watch: {
    dateObject(value, oldvalue) {
      this.form.beginTime = value["beginTime"]
      this.form.endTime = value["endTime"]
      this.onRefresh()
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    onLoad() {
      getAllOrder(this.form)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.form.pageNum === 1) {
              this.finished = false
              this.dataSource = data
            } else {
              this.dataSource = this.dataSource.concat(data)
            }
            if (data.length < this.form.pageSize) {
              this.finished = true
            } else {
              this.form.pageNum++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.loading = false
          this.refreshing = false
          this.finished = true
          this.$toast(e.msg || e.message)
        })
    },
    onRefresh() {
      this.form.pageNum = 1
      this.onLoad()
    },
    onPay(item) {
      //item.payType 1 余额 2 在线（银行卡支付） 3 线下
      // if (this.countDown(item) > 0) {
      this._showLoading()
      this.payForm.payAmount = Number(item.payAmount / 100)
      this.payForm.id = item.id
      this.payForm.tradeAmount = item.tradeAmount / 100
      this.payForm.fundOutType = item.fundOutType
      this.payForm.productId = item.productId
      this.payForm.bindCardId = item.bindCardId
      this.payForm.pattern_buying =
        item.payType == 1 ? "3" : item.payType == 2 ? "2" : ""
      this.payForm.type =
        item.payType == 1 ? "offline" : item.payType == 2 ? "online" : ""
      localStorage.removeItem("payForm")
      localStorage.setItem("payForm", JSON.stringify(this.payForm))
      session.setJson("payForm", this.payForm)
      if (item.productType == 4) {
        this._dismissLoading()
        this.$router.push({
          name: "orderconfirm",
          params: { countDownTime: item.countDownTime }
        })
      } else {
        if (item.signStatus == 1) {
          if (item.productType == 1) {
            // 产品类型 1-债券类型 2-拍卖类型 4-体验产品
            //未签署
            // this.getSignaturePDF()
            this.getProductDetial(item.productId)
          } else {
            //未签署
            this.getAuctionSignaturePDF(item.id)
          }
        } else if (item.signStatus == 2) {
          //签署完成
          this._dismissLoading()
          this.$router.push({
            name: "orderconfirm",
            params: { countDownTime: item.countDownTime }
          })
        }
      }
      // } else {
      //   this.$toast("支付时间已超时，不能进行支付操作")
      // }
    },
    onCancelWithdraw(item) {
      this._showTipsInfo(
        "提现撤销确认",
        `您正在操作撤销该笔${this.numFormat(
          item.tradeAmount
        )}元的提现（仅在申请中的提现可撤销），确认撤销后该笔资金将退回至您平台账户余额。`,
        "取消",
        "确认",
        () => {
          cancelWithdraw(item.id)
            .then((data) => {
              this.$toast("撤销成功")
              this.getUserInfo()
              this.onRefresh()
            })
            .catch((e) => {
              this.$toast(e.msg || e.message)
            })
        },
        () => {},
        "left"
      )
    },
    // 获取e签宝
    getSignaturePDF() {
      PayApi.getSignatureUrl({ id: this.payForm.id })
        .then((data) => {
          this._dismissLoading()
          location.href = data
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },

    // 获取拍品e签宝
    getAuctionSignaturePDF(orderId) {
      PayApi.getAuctionSignatureUrl(orderId)
        .then((data) => {
          this._dismissLoading()
          location.href = data
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    getProductDetial(productId) {
      // 处理特殊订单签署
      ProductApi.detail(productId)
        .then((data) => {
          if (data) {
            if (
              data.isProductBaseAccount === 1 ||
              data.isProductBaseAccount === 2
            ) {
              // 0：普通产品 1：特殊产品1 2：特殊产品2 是否限定为针对产品账户设置的产品，除了产品账户之外的余额无法购买
              this.getSpecialSignaturePDF()
            } else {
              this.getSignaturePDF()
            }
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    // 获取特殊订单e签宝
    getSpecialSignaturePDF() {
      SpecialPayApi.specialProtocolSign(this.payForm)
        .then((data) => {
          this._dismissLoading()
          location.href = data
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    countDown(item) {
      if (item.countDownTime) {
        let time = moment(item.countDownTime).diff(Date.now())
        return time
      } else {
        return 0
      }
    },
    onFinish(item) {
      item.status = 201
    }
  }
}
</script>

<style lang="less" scoped>
.van-cell {
  padding: 0;
  width: calc(100% - 30px);
}

.item {
  margin: 15px 15px 0 15px;
  border-radius: 8px;
  .item-bg {
    padding: 0 10px;
    .amount {
      color: black;
      font-size: 15px;
      font-weight: 500;
      margin-top: 15px;
    }
    .title {
      margin-top: 10px;
      color: rgb(102, 102, 102);
      font-size: 14px;
    }
    .order-num {
      margin-top: 5px;
      color: rgb(102, 102, 102);
      font-size: 14px;
    }
    .create-time {
      margin-top: 5px;
      color: rgb(167, 167, 167);
      font-size: 12px;
    }
    .bottom-line {
      background-color: rgb(247, 247, 247);
      margin: 10px 0 10px -10px;
      height: 1px;
    }
    .bottom-bg {
      display: flex;
      justify-content: space-between;
      margin: 15px 0 10px 0;
      .status-bg {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
        .status {
          color: rgb(102, 102, 102);
          font-size: 12px;
        }
      }
      .pay-btn {
        font-size: 12px;
        color: rgb(79, 160, 248);
        border: 1px rgb(79, 160, 248) solid;
        height: 24px;
        padding: 5px;
      }
      .cancel-order-btn {
        font-size: 12px;
        color: rgb(102, 102, 102);
        border: 1px rgb(102, 102, 102) solid;
        height: 24px;
        padding: 10px;
      }
    }

    .tag {
      position: absolute;
      right: 0;
      top: 12px;
      background-color: rgb(100, 209, 159);
      height: 24px;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 12px;
      padding: 0px 15px;
    }
  }
}
</style>